import { render, staticRenderFns } from "./BoletoType.vue?vue&type=template&id=2a0a368f&"
import script from "./BoletoType.vue?vue&type=script&lang=ts&"
export * from "./BoletoType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports